// extracted by mini-css-extract-plugin
export default {"wrapper":"Portfolio_wrapper__1fS5X","container":"Portfolio_container__Z2VT1","heading":"Portfolio_heading__6BYq7","showCase":"Portfolio_showCase__5awoQ"};